import { render, staticRenderFns } from "./RelatedItems.vue?vue&type=template&id=b72f7056&scoped=true"
import script from "./RelatedItems.vue?vue&type=script&lang=js"
export * from "./RelatedItems.vue?vue&type=script&lang=js"
import style0 from "./RelatedItems.vue?vue&type=style&index=0&id=b72f7056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72f7056",
  null
  
)

export default component.exports